//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "backOrderDetailAll",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/pages/backOrder/detailAll.vue